import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './FoldableGroupList';
import { getIsSectionFolded } from '../../redux/selectors';
import { updateNetworkBarSection } from '../../redux/actions';

export type StateProps = Pick<Props, 'isFolded'>;
export type DispatchProps = Pick<Props, 'onFoldToggle'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  { sectionType }
) => ({
  isFolded: getIsSectionFolded(state, sectionType),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onFoldToggle: updateNetworkBarSection,
};

export default connect(mapStateToProps, mapDispatchToProps);
